import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';
import { getIsInSidebar } from 'platform-specific/url';
import { SkeletonConversationScreen } from 'structure/question/loading-screen';
import { SkeletonStandaloneConversationScreen } from 'structure/question/standalone-loading-screen';

const moduleFn = () => import('feature/profile/profile-module');

export function SuspenseFallback() {
    return <ProfileLoadingScreen />;
}

export default function ProfileInstanceLayout() {
    const { siloKey, instanceKey } = useLocalSearchParams<'/[siloKey]/profile/[instanceKey]'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'profile',
        instanceKey,
        moduleFn,
    });
    return (
        <DatastoreProvider {...instanceConfig} loadingScreen={<ProfileLoadingScreen />}>
            <InstanceStack />
        </DatastoreProvider>
    );
}

function ProfileLoadingScreen() {
    if (getIsInSidebar()) {
        return <SkeletonConversationScreen />;
    }

    return <SkeletonStandaloneConversationScreen />;
}
